import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpModel } from './../../core/models/user-management/help-model';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  myInnerHeight: any;
  iframeSRC: any = null;
  isLoading = true;
  helpData: HelpModel;

  constructor(public sanitizer: DomSanitizer, private userManagement: UserManagementService) {
    this.helpData = new HelpModel();
  }

  ngOnInit(): void {
    this.myInnerHeight = window.innerHeight;
    this.fetchHelpData();
  }

  fetchHelpData(): void {
    this.userManagement.getHelpData().subscribe((result: HelpModel) => {
      this.helpData = result;
      this.iframeSRC = this.sanitizer.bypassSecurityTrustResourceUrl('../assets/docs/index.htm');
    });
  }
}
